import React from "react";

export const PokemonListContext = React.createContext();

export const PokemonContext = React.createContext();